import { useEffect, useState } from "react";
import ProductCard from "@/components/products/ProductCard";
import {
  fetchCategoryByService,
  fetchProducts,
  type Product,
  type ProductCategory,
} from "@/lib/products";

interface Props {
  /** Tjänstens slug, t.ex. "solceller" */
  serviceSlug: string;
  limit?: number;
}

/** Produktkatalog som visas under en tjänstesida. */
const ProductCatalogSection = ({ serviceSlug, limit = 6 }: Props) => {
  const [category, setCategory] = useState<ProductCategory | null>(null);
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const cat = await fetchCategoryByService(serviceSlug);
        if (!active || !cat) return;
        const list = await fetchProducts(cat.id);
        if (!active) return;
        setCategory(cat);
        setProducts(list);
      } catch {
        /* katalogen är inte kritisk för sidan */
      }
    })();
    return () => {
      active = false;
    };
  }, [serviceSlug]);

  if (!category || products.length === 0) return null;

  return (
    <section aria-labelledby="produktkatalog">
      <div className="mb-8">
        <div>
          <h2 id="produktkatalog" className="heading-2">
            Populära produkter – {category.name.toLowerCase()}
          </h2>
          {category.description && (
            <p className="text-muted-foreground mt-2 max-w-2xl">{category.description}</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
        {products.slice(0, limit).map((p) => (
          <ProductCard key={p.id} product={p} category={category} />
        ))}
      </div>
    </section>
  );
};

export default ProductCatalogSection;
